function toPathSegments(path) {
  if (Array.isArray(path)) {
    return path.filter(Boolean);
  }

  return String(path || "")
    .split(".")
    .filter(Boolean);
}

function readNestedValue(source, path) {
  if (!source || typeof source !== "object") return undefined;

  return toPathSegments(path).reduce((current, segment) => {
    if (current == null || typeof current !== "object") {
      return undefined;
    }

    return current[segment];
  }, source);
}

function assignNestedValue(target, path, value) {
  const segments = toPathSegments(path);
  if (!segments.length) return target;

  let current = target;

  for (let index = 0; index < segments.length; index += 1) {
    const segment = segments[index];
    const isLeaf = index === segments.length - 1;

    if (isLeaf) {
      current[segment] = value;
      continue;
    }

    if (!current[segment] || typeof current[segment] !== "object") {
      current[segment] = {};
    }

    current = current[segment];
  }

  return target;
}

export function readSnapshotField(snapshot, path) {
  if (!snapshot || !path) return undefined;

  if (typeof snapshot.get === "function") {
    return snapshot.get(path);
  }

  const sourceData =
    typeof snapshot.data === "function" ? snapshot.data() || {} : snapshot;

  return readNestedValue(sourceData, path);
}

export function buildSnapshotSubset(snapshot, fieldPaths) {
  if (!snapshot || !Array.isArray(fieldPaths) || !fieldPaths.length) {
    return {};
  }

  const target = {};
  const sourceData =
    typeof snapshot.get === "function"
      ? null
      : typeof snapshot.data === "function"
        ? snapshot.data() || {}
        : snapshot;

  for (const fieldPath of fieldPaths) {
    const value =
      typeof snapshot.get === "function"
        ? snapshot.get(fieldPath)
        : readNestedValue(sourceData, fieldPath);

    if (value === undefined) continue;
    assignNestedValue(target, fieldPath, value);
  }

  return target;
}
